import React, { forwardRef, Ref } from 'react';
import {
  Thumbnail2d,
  ThumbnailTypes,
  ThumbnailFormat,
  ThumbnailGameIconSize
} from 'roblox-thumbnails';
import { Link } from 'react-style-guide';
import { TGameTileProps, GameTileStats } from './GameTileUtils';
import { FeatureGamePage } from '../constants/translationConstants';
import '../../../../css/common/_gameTiles.scss';

export const GameTileBase = ({
  id,
  gameData,
  onTileClick,
  children
}: Omit<TGameTileProps, 'translate'> & { children: JSX.Element }): JSX.Element => {
  return (
    <Link
      onClick={() => {
        onTileClick(gameData, id);
      }}
      className='game-card-link'
      id={gameData.universeId.toString()}>
      <Thumbnail2d
        type={ThumbnailTypes.gameIcon}
        size={ThumbnailGameIconSize.size150}
        targetId={gameData.universeId}
        containerClass='game-card-thumb-container'
        format={ThumbnailFormat.jpeg}
        altName={gameData.name}
      />
      <div className='game-card-name game-name-title' title={gameData.name}>
        {gameData.name}
      </div>
      {children}
    </Link>
  );
};

export const GameTile = forwardRef(
  ({ id, onTileClick, gameData }: TGameTileProps, ref: Ref<HTMLDivElement>): JSX.Element => {
    return (
      <div ref={ref} className='grid-item-container game-card-container'>
        <GameTileBase id={id} onTileClick={onTileClick} gameData={gameData}>
          <GameTileStats
            totalUpVotes={gameData.totalUpVotes}
            totalDownVotes={gameData.totalDownVotes}
            playerCount={gameData.playerCount}
          />
        </GameTileBase>
      </div>
    );
  }
);

export const SponsoredGameTile = forwardRef(
  (
    { translate, id, onTileClick, gameData }: TGameTileProps,
    ref: Ref<HTMLDivElement>
  ): JSX.Element => {
    return (
      <div ref={ref} className='grid-item-container game-card-container'>
        <GameTileBase id={id} onTileClick={onTileClick} gameData={gameData}>
          <div className='game-card-native-ad'>
            <div className='native-ad-label'>{translate(FeatureGamePage.LabelSponsoredAd)}</div>
          </div>
        </GameTileBase>
      </div>
    );
  }
);

export const LoadingGameTile = (): JSX.Element => {
  return (
    <div className='grid-item-container game-card-container game-card-loading'>
      <div className='game-card-thumb-container shimmer' />
      <div className='game-card-name game-name-title shimmer' />
      <div className='game-card-name game-name-title game-name-title-half shimmer' />
    </div>
  );
};

export default {
  GameTileBase,
  GameTile,
  SponsoredGameTile,
  LoadingGameTile
};
